import { Component, Input } from '@angular/core';
import { SkeletonConfig } from './skeleton.config';

@Component({
  selector: 'dn-skeleton-loader',
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss',
  standalone: false,
})
export class SkeletonComponent {
  @Input() type: SkeletonConfig = SkeletonConfig.PROFILE;
  skeletonOptions = SkeletonConfig;
}
